exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listitems-item {\n  display: flex;\n}\n\n.listitems-item>* {\n  display: flex;\n  align-items: center;\n}\n\n.listitems-item .listitems-item__icon {\n  width: 6.6rem;\n  display: flex;\n  align-items: center;\n  font-size: 3.4rem;\n  flex-shrink: 0;\n}\n\n.listitems-item .listitems-item__title {\n  flex-grow: 1;\n}\n\n.listitems-item .listitems-item__title.listitems-item__title--red {\n  color: #FF0049;\n}\n\n.listitems-item .listitems-item__arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #839AA7;\n  margin-left: 3rem;\n}\n\n", ""]);

// exports
